import type { Map as LeafletMap } from "leaflet"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useMap } from "react-leaflet"

export interface IMapReferenceProps {
  onMapReference: (map: LeafletMap) => void
}

export function MapReference(props: IMapReferenceProps): ReactElement {
  const reference: LeafletMap = useMap()
  const { onMapReference } = props

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    if (reference) {
      onMapReference(reference)
    }
  }, [reference])

  return <></>
}
